/**
 * Calculates the percentage coverage taking the
 * current daily sessions versus the plan daily allowances
 */
export function calculateCoverage(dailySessions: number, dailyAllowance: number): number {
  return Math.min(100, Math.floor((dailyAllowance / dailySessions) * 100));
}
